import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './UtilitiesComponent.metadata.json5';

function UtilitiesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('UtilitiesComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        priHeaFueTypFie: {
            visible: !_.isUndefined(_.get(modelVM, 'priHeaFie.value'))
                && _.get(modelVM, 'priHeaFie.value.code') !== 'None'
        },
        ifOthExpFie1: {
            visible: _.get(modelVM, 'priHeaFie.value.code', '') === 'Other'
        },
        ifOthExpFie4: {
            visible: _.get(modelVM, 'priHeaFie.value.code') !== 'None'
                && _.get(modelVM, 'priHeaFueTypFie.value.code') === 'Oth'
        },
        yealasupdFie2: {
            visible: _.get(modelVM, 'priHeaFie.value.code', '') !== 'None'
        },
        annCorofWooBurFie2: {
            defaultValue: 0,
            visible: (!_.isUndefined(_.get(modelVM.value, 'priHeaFie')) && _.get(modelVM.value, 'priHeaFie') === 'ComWitWoo')
                || (!_.isUndefined(_.get(modelVM.value, 'priHeaFueTypFie')) && _.get(modelVM.value, 'priHeaFueTypFie') === 'Wood')
        },
        annBagofPelBurFie3: {
            defaultValue: 0,
            visible: (!_.isUndefined(_.get(modelVM.value, 'priHeaFie')) && _.get(modelVM.value, 'priHeaFie') === 'ComWitWoo')
                || (!_.isUndefined(_.get(modelVM.value, 'priHeaFueTypFie')) && _.get(modelVM.value, 'priHeaFueTypFie') === 'Wood')
        },
        auxHeaFueTypFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code', '') !== 'None'
        },
        ifOthExpFie8: {
            visible: _.get(modelVM, 'auxHeaFueTypFie.value.code', '') === 'Oth'
        },
        yealasupdFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code', '') !== 'None'
        },
        annCorofWooBurFie: {
            visible: _.get(modelVM, 'auxHeaFueTypFie.value.code', '') === 'Wood' ||  _.get(modelVM, 'auxHeaFie.value.code', '') === 'ComWitWood'
        },
        annBagofPelBurFie: {
            visible: _.get(modelVM, 'auxHeaFueTypFie.value.code', '') === 'Wood' || _.get(modelVM, 'auxHeaFie.value.code', '') === 'ComWitWood'
        },
        ifOthExpFie6: {
            visible: _.get(modelVM, 'othFie.value', '') === true
        },
        ifOthExpFie: {
            visible: _.get(modelVM, 'typofPluFie.value.code', '') === 'Oth'
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

UtilitiesComponent.propTypes = wizardProps;
export default withRouter(UtilitiesComponent);